<template lang="pug">
aside-modal(:id="id", width="w-xxxl", :loading="onLoading('fetch-transaction')")
    span(slot="header-text") {{ hasTransaction && isVoided && !loading ? 'Voided' : '' }} Receipt
    div.padding.receipt(slot="body")
        div(v-if="hasTransaction && ! loading")
            receipt-details
            receipt-orders
            receipt-amount
            receipt-footer
        div(v-else)
            h1.text-center
                v-loading(loader="fetch-transaction")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import receiptDetails from './details.vue';
import receiptOrders from './orders.vue';
import receiptAmount from './amount.vue';
import receiptFooter from './footer.vue';

export default {
    components: {
        receiptDetails,
        receiptOrders,
        receiptAmount,
        receiptFooter,
    },
    props: {
        id: {
            type: String,
            default: 'receipt',
        },
    },

    computed: {
        ...mapGetters('transaction', ['receipt', 'hasTransaction', 'isVoided']),

        loading() {
            return this.onLoading('fetch-transaction');
        },
    },

    created() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('transaction', ['getPublicTransaction']),

        print() {
            if (this.receipt && this.receipt.transaction_id) {
                window.location.href = Laroute.route(
                    'franchise.report.transaction.exportReceipt',
                    { id: this.receipt.transaction_id },
                );
            }
        },

        registerEvent() {
            // Event untuk public receipt dengan franchise_id dan transaction_id
            this.$on(
                'show-public-receipt',
                ({ franchise_id, transaction_id }) => {
                    if (this.loading) return;

                    this.toggleModal('show');
                    this.getPublicTransaction({ franchise_id, transaction_id });
                },
            );
        },

        toggleModal(action) {
            $('#receipt').modal(action);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/public-receipt.vue